import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPlanList extends Layout {
    layoutheaderCarrierPlan: LayoutHeader;
    sourceCarrierPlanLookup: DataSource;
    tableCarrierPlans: Table;
}
